import { render } from "./ProfilPage.vue?vue&type=template&id=5a4734b7&scoped=true"
import script from "./ProfilPage.vue?vue&type=script&lang=js"
export * from "./ProfilPage.vue?vue&type=script&lang=js"

import "./ProfilPage.vue?vue&type=style&index=0&id=5a4734b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a4734b7"]])

export default __exports__